import { Text } from "@/components/ui/baseUi/text"

type CoachSectionCardProps = {
  title: string
  subtitle?: string
}

export function CoachSectionCard({ title, subtitle }: CoachSectionCardProps) {
  return (
    <div className="flex flex-col gap-1 border-l-2 border-interactive-border-primary-default pl-3">
      <Text fontStyle="TS" className="font-semibold text-textOnSurface-default">
        {title}
      </Text>
      {subtitle && (
        <Text fontStyle="BM" className="text-textOnSurface-subtle">
          {subtitle}
        </Text>
      )}
    </div>
  )
}
